<template>
    <div>
        <div class="container card p-5 shadow col-md-4 m-auto">
            <h2>{{$t('CREATE_SHEET')}}</h2>
            <hr>
            <form id="form" @submit.prevent="submitCreateSheetForm">
                <div class="input-group mb-3">
                    <label for="weight" id="inputGroup-sizing-lg" class="col-form-label col-xl-2 col-lg-3">{{$t('NAME')}}</label>
                    <input type="text" v-model="sheetName" class="form-control">
                </div>
                <div class="input-group mb-3">
                    <label for="sheet-name" class="col-form-label col-xl-2 col-lg-3">{{$t('WEIGHT')}}</label>
                    <input type="text" v-model.number="sheetWeight"  class="form-control">
                </div>
                <div>
                    <button type="submit" class="btn float-right">{{$t('CREATE')}}</button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                sheetName: '',
                sheetWeight: 0
            }
        },
        computed: {
            cgaPatient() {
                return this.$store.getters.cgaPatient || this.emptyCgaPatient;
            },
            activeSheet() {
                return this.$store.getters.cgaPatientSheet;
            }
        },
        methods: {
            submitCreateSheetForm: function() {
                let self = this;
                this.$store.dispatch("createSheet", {
                    name: self.sheetName, 
                    weight: self.sheetWeight
                })
                .then(response => {
                    
                })
                .catch(error => {

                });
            }
        },
        mounted: function () {

        }
    }
</script>
<style lang="scss" scoped>
    .input-group-text {
        width: 80px;
    }
</style>